module.exports = __webpack_public_path__ + "img/mercadoenvios.9dfb6abd.svg";